(function registerDecimalInput(scope: any) {
  // Keep the editable text while the owner stores a number. A trailing comma,
  // decimal point or zero is meaningful input even though Number removes it.
  const useInput = (props: any, enabled: boolean, React = scope.React) => {
    const [draft, setDraft] = React.useState(props.value === undefined ? String(props.defaultValue ?? '') : null as string | null);
    const focused = React.useRef(false);
    React.useEffect(() => { if (!focused.current && props.value !== undefined) setDraft(null); }, [props.value]);
    if (!enabled) return {};
    return {
      type: 'text', inputMode: 'decimal', defaultValue: undefined, value: draft ?? props.value ?? '',
      onFocus: (event: any) => { focused.current = true; props.onFocus?.(event); },
      onChange: (event: any) => {
        const editable = scope.PlummeMoneyInput.normalizeEditable(event.target.value, { maxDecimals: props.maxDecimals ?? 3, preferDecimal: true });
        const parsed = scope.PlummeMoneyInput.analyze(editable, { allowPartial: true, preferDecimal: true });
        if (!parsed) return;
        setDraft(editable);
        // Existing callers using Number/parseFloat receive a canonical decimal.
        event.target.value = parsed.canonical === '-' ? '' : parsed.canonical;
        props.onChange?.(event);
      },
      onBlur: (event: any) => { focused.current = false; if (props.value !== undefined) setDraft(null); props.onBlur?.(event); },
    };
  };
  scope.PlummeDecimalInput = { useInput };
})(window);
